export default "__VITE_ASSET__qH2xErBp__"